import {
  faCopy,
  faList,
  faPencil,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import IMerchProductOrder from '../../../../models/restful/IMerchProductOrder';
import PATHS from '../../../../paths';
import './OrdersActions.scss';

import IMerchProductOrderView from 'models/restful/IMerchProductOrderView';
import { apiV2 } from '../../../../api/ApiV2';
import { useUser } from '../../hooks/useUser';
import { OrdersTablePageSettings } from '../OrdersTablePage';

interface IOrderActionsProps {
  order: IMerchProductOrderView & { Name: string };
  updateFromServer(): void;
}

const OrderActions: React.FunctionComponent<IOrderActionsProps> = props => {
  const o = props.order;
  const navigate = useNavigate();
  const { getUser } = useUser();
  const user = getUser();

  if (!o.Name) return null;
  const duplicateOrder = (order: IOrderActionsProps['order']) => {
    apiV2.order
      .duplicateOrder({
        id: +order.Name
      })
      .then(resp => {
        const order = resp.item as IMerchProductOrder;
        OrdersTablePageSettings.isUpdateNeeded = true;
        navigate(generatePath(PATHS.ORDER_EDIT, { name: order.Name }));
      });
  };

  const deleteOrders = (ids: number[]) => {
    apiV2.crud
      .delete({
        dataObjectName: 'MerchProductOrder',
        ids: ids
      })
      .then(() => {
        props.updateFromServer();
      });
  };

  return (
    <>
      <Link
        className="btn btn-outline-secondary btn-sm order-action-btn"
        to={generatePath(PATHS.ORDER_VIEW, { name: o.Name })}
      >
        <FontAwesomeIcon icon={faList} className="ms-1 fs-9" />
        &nbsp; View
      </Link>
      {o.PaymentStatus === 'NONE' && (
        <Link
          className="btn btn-outline-primary btn-sm store-action-btn"
          to={generatePath(PATHS.ORDER_EDIT, { name: o.Name })}
        >
          <FontAwesomeIcon icon={faPencil} className="ms-1 fs-9" />
          &nbsp; Edit
        </Link>
      )}
      <button
        className="btn btn-outline-success btn-sm order-action-btn"
        onClick={() =>
          window.confirm('Really copy order?') ? duplicateOrder(o) : null
        }
      >
        <FontAwesomeIcon icon={faCopy} className="ms-1 fs-9" />
        &nbsp; Copy
      </button>
      {user.IsAdmin && ( //|| o._props.canDelete
        <button
          className="btn btn-outline-danger btn-sm order-action-btn"
          onClick={() =>
            window.confirm('Really delete order?')
              ? deleteOrders([+o.Name])
              : null
          }
        >
          <FontAwesomeIcon icon={faTrash} className="ms-1 fs-9" />
          &nbsp; Delete
        </button>
      )}
      {/* TODO: check if canPay property exists */}
      {/* {o._props.canPay && (
        <button
          className="btn btn-outline-success btn-sm order-action-btn"
          onClick={() =>
            window.confirm('Really pay order?') ? pay([o.ID]) : null
          }
        >
          <FontAwesomeIcon icon={faMoneyBill} className="ms-1 fs-9" />
          &nbsp; Pay
        </button>
      )} */}
    </>
  );
};

export default OrderActions;
